import { TabsProps } from 'antd';
import { useProcContext } from '@/entities/proc';
import { EditProcComponentsTab } from '@/pages/proc/EditProcComponentsTab';
import { DashboardSidebarRightTabsType } from '@/shared/types';
import { Tabs } from '@/shared/ui';
import { ProcLogicTab } from '../proc-logic';

const items: TabsProps['items'] = [
  {
    key: DashboardSidebarRightTabsType.Components,
    label: `Components`,
    children: <EditProcComponentsTab />,
  },
  {
    key: DashboardSidebarRightTabsType.Logic,
    label: `Logic`,
    children: <ProcLogicTab />,
  },
];

export const EditProcSidebarRightTabs = () => {
  const { rightSidebarActiveTab, setRightSidebarActiveTab } = useProcContext();

  return (
    <Tabs
      data-testid="sidebar-right-tabs"
      type="line"
      activeKey={rightSidebarActiveTab}
      items={items}
      tabBarGutter={20}
      onChange={(key) =>
        setRightSidebarActiveTab(key as DashboardSidebarRightTabsType)
      }
      tabBarStyle={{ paddingInline: 15 }}
    />
  );
};
